package music.jammers.shared.event.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class CardInfo(
    val id: Long,
    val name: String,
    val textColor: String,
    val backgroundUrl: String,
) {

    companion object {

        val INVALID = CardInfo(
            id = -1L,
            name = "",
            textColor = "",
            backgroundUrl = "",
        )
    }
}